import { createElement } from 'rax';
import EmbedMonthPicker from '../embed-picker/month-picker';
import BasePicker from './base-picker';
export default class MonthPicker extends BasePicker {
    renderPicker() {
        return (<EmbedMonthPicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} onChange={this.handleChange} validRange={this.props.validRange}/>);
    }
    getDefaultFormat() {
        return 'YYYY-MM';
    }
}
